<ul class="skills" [class.skills--left-align]="leftAlign" [attr.itemprop]="addStructuredData ? 'skills' : null">
  <li *ngFor="let skill of model; trackBy: trackBySkill" class="skills__tag">{{ skill }}</li>
</ul>
